import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconSizeEnum, SdIconComponent, SdModalDefaultComponent } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-product-seller-modal',
  templateUrl: './product-seller-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./product-seller-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SdModalDefaultComponent, SdIconComponent, TranslateModule]
})
export class SdProductSellerModalComponent {
  iconSize = IconSizeEnum;

  @Input()
  isOpened = false;

  @Output()
  isOpenedChange = new EventEmitter<boolean>();

  @Output()
  toggleModal = new EventEmitter<void>();
}
